import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import useAPI from './useApi';
import { brokerCapabilitiesUrl } from '../services/brokerApi';
import { isBrokerLinked } from '../utils/brokerConnection';
import { TradingContext } from '../contexts/TradingContext';

export const brokerCapabilitiesQueryKey = ['broker', 'capabilities'];

/**
 * Fetches GET /broker/capabilities for the connection that owns the selected account.
 * Query key includes accountId so switching brokers/accounts refetches endpoint toggles.
 */
export default function useBrokerCapabilities(user) {
  const { request } = useAPI();
  const { selectedAccount } = useContext(TradingContext);
  const accountId = selectedAccount?.AccountID || null;
  const connectionId = selectedAccount?.ct_connection_id || selectedAccount?.connection_id || null;
  const enabled = !!user?.token && isBrokerLinked(user);

  return useQuery({
    queryKey: [...brokerCapabilitiesQueryKey, accountId || 'default', connectionId || ''],
    queryFn: () => request(brokerCapabilitiesUrl(accountId, connectionId), {}, 'GET'),
    enabled,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
}
